export default "__VITE_ASSET__1zwqj55$__"